function readCookie(name: string): string | null {
  const prefix = `${name}=`
  for (const part of document.cookie.split(';')) {
    const cookie = part.trim()
    if (cookie.startsWith(prefix)) return decodeURIComponent(cookie.slice(prefix.length))
  }
  return null
}

export async function bffFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers)
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')

  if (!['GET', 'HEAD', 'OPTIONS'].includes(init.method ?? 'GET')) {
    const csrfToken = readCookie('__Host-inko_csrf_token') ?? readCookie('inko_csrf_token')
    if (csrfToken) headers.set('X-CSRF-Token', csrfToken)
  }

  return fetch(path, {
    ...init,
    credentials: 'same-origin',
    headers,
  })
}
